import {
    defineStore,
    _ActionsTree,
    _GettersTree
} from "pinia";
import _ from 'lodash'
import UserApi from "~/serverapi/User"
import usePub from "~/store/Public"
import http from '~/serverapi/http'
export interface StoreState {
    LoginInfo: {
        status: boolean,
        api_token: string,
        name: string,
        method: string,
        tourCode: string,
        tourName: string,
        startDate: string,
        days: number,
        loginCode: string
    },

}


// 建議以initState先聲明在useStore之前，這樣比較好用，尤其是reset的情況特別好用
const initState: StoreState = {
    LoginInfo: {
        status: false,
        name: "",
        method: "",
        tourCode: "",
        tourName: "",
        startDate: "",
        days: 0,
        loginCode: "",
        api_token: ""
    }
}
const getters: _GettersTree<StoreState> = {
    getSort(state) {

    },
    // getTripleCount: (state) => state.count * 3,
}
const useStore = defineStore("Leader", {
    state: () => { return _.cloneDeep(initState) },
    actions: {
        async checkUser() {
            return http.get(`Leader/checkLogin`);
        },
        async getUser() {
            const result = await http.get(`Leader/getUser`);
            if (result.status) {
                this.LoginInfo.status = result.status;
                this.LoginInfo.name = result.result.name;
                this.LoginInfo.method = result.result.method;
                this.LoginInfo.startDate = result.result.startDate;
                this.LoginInfo.tourCode = result.result.tourCode;
                this.LoginInfo.tourName = result.result.tourName;
                this.LoginInfo.days = result.result.days;
                this.LoginInfo.loginCode = result.result.loginCode;
            }
        },
        async Login(loginCode: string, idcard: string) {
            const result = await http.post(`Leader/Login/${loginCode}`, {
                pwd: idcard
            });
            if (result.status) {
                this.LoginInfo.status = result.status;
                this.LoginInfo.name = result.result.name;
                this.LoginInfo.method = result.result.method;
                this.LoginInfo.api_token = result.result.api_token
                localStorage.setItem("auth", this.LoginInfo.api_token);
            } else {
                this.LoginInfo.status = false;
                this.LoginInfo.name = "";
                this.LoginInfo.method = "";
                this.LoginInfo.api_token = ""
                localStorage.setItem("auth", "");
            }
            return result;
        },
        async getBulletin() {
            return http.get("Leader/getBulletin")
        },
        async editBulletin(formdata: any) {
            return http.post("Leader/editBulletin", formdata);
        },
        async getReplyMessage(method: string, page: number, lastTime: string) {
            return http.get(`Leader/getReplyMessage/${method}/${page}`, {
                lastTime: lastTime
            });
        },
        async getGroupMember() {
            return http.get(`Leader/getGroupMember`);
        },
        async sendMessage(group: string, message: string) {
            return http.post(`Leader/sendMessage/${group}`, {
                message: message
            });
        },
        getSchedule(days: number | string) {
            return http.get(`Leader/getSchedule/${days}`);
        },
        async setPosition(data: object) {
            return http.post(`Leader/setPosition`, data);
        },

        async getPosition(method: Array<string>,day:number) {
            return http.get(`Leader/getPosition`, {
                method: method.join(","),
                day:day
            });
        }
    },
    getters,
});
export default useStore;